import React from 'react';
import './OurReviews.css';

const OurReviews: React.FC = () => {
    return (
        <div className="our-reviews-content">
            <div className="reviews-intro">
                <p>
                    <a
                        href="https://www.facebook.com/DeliFeed"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="facebook-reviews-link"
                    >
                        Check out our reviews on Facebook →
                    </a>
                </p>
            </div>
            <div className="reviews-image-container">
                <img src="/files/reviews.png" alt="Customer Reviews" className="reviews-image" />
            </div>
        </div>
    );
};

export default OurReviews;
